import * as JsSearch from 'js-search';
import React, { Component, PropTypes } from 'react';

const search = new JsSearch.Search('text');
search.addIndex('text');
export { search };



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/provider/ConfigSearchIndex.js